var _style, _path, _path2, _rect, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "2780.4px",
    height: "1242.2px",
    viewBox: "0 0 2780.4 1242.2",
    style: {
      enableBackground: "new 0 0 2780.4 1242.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D3D3D3;}\r\n\t.st1{fill:#DDB28E;}\r\n\t.st2{opacity:0.3;enable-background:new    ;}\r\n\t.st3{opacity:0.1;enable-background:new    ;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2486.3,819.6v422.7h-84.1v-124H379.5v124h-84.1V819.6h84.1h2022.7H2486.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2769.7,707.6V776c0,24.1-19.5,43.6-43.6,43.6h-321.5v224H382v-224H55.9c-24.3,0-44-19.7-44-44v-68l341-644.4 c17-32.2,50.4-52.3,86.9-52.3H2342c36.4,0,69.8,20.1,86.9,52.3L2769.7,707.6z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 379.5,
    y: 819.6,
    className: "st2",
    width: 2022.7,
    height: 224
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2726.2,819.6H55.9c-24.3,0-44-19.7-44-44v-68h2757.8V776C2769.7,800,2750.2,819.6,2726.2,819.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg17);
export default __webpack_public_path__ + "static/media/17.39d373b144b4e0890372374d2d67de08.svg";
export { ForwardRef as ReactComponent };